/**
 * Message type checking utilities
 */

export const isUserMessage = data => {
  return data?.source === 'user' || data?.source === 'user_proxy';
};
export const isSegmentQueryMessage = data => {
  return data?.type === 'StructuredMessage[SegmentQuery]';
};
export const isQCHandoffToken = data => {
  return data?.type === 'StructuredMessage[QCHandoffToken]';
};
export const isSegmentAnalystHandoffToken = data => {
  return data?.type === 'StructuredMessage[SegmentAnalystHandoffToken]';
};
export const isScopingHandoffToken = data => {
  return data?.type === 'StructuredMessage[ScopingHandoffToken]';
};
export const isToolCallEvent = data => {
  return data?.type === 'ToolCallRequestEvent' || data?.type === 'ToolCallExecutionEvent' || data?.type === 'ToolCallSummaryEvent' || data?.type === 'ToolCallSummaryMessage';
};
export const isHTMLTemplateMessage = data => {
  return data?.type === 'StructuredMessage[HTMLTemplate]';
};
export const isTemplateAnalystHandoffToken = data => {
  return data?.type === 'StructuredMessage[TemplateAnalystHandoffToken]';
};
export const isStreamingChunkEvent = data => {
  return data?.type === 'ModelClientStreamingChunkEvent';
};
export const isHTMLTemplateEngineerHandoff = data => {
  return isScopingHandoffToken(data) && data?.metadata?.handoff_token === 'HTML_TEMPLATE_ENGINEER';
};
export const isSQLEngineerHandoff = data => {
  return isScopingHandoffToken(data) && data?.metadata?.handoff_token === 'SQL_ENGINEER';
};
export const isJourneyBuilderHandoff = data => {
  return isScopingHandoffToken(data) && data?.metadata?.handoff_token === 'JOURNEY_BUILDER';
};
export const isUserReviewHandoff = (data, messageType) => {
  const handoffToken = data?.metadata?.handoff_token;
  return messageType && handoffToken === 'USER_REVIEW';
};